import { takeLatest, put, call } from 'redux-saga/effects';
import type { SagaReturnType } from 'redux-saga/effects';
import { documentBundleActions } from 'src/redux/actions/constant';
import documentBundleService from 'src/services/apiServices/document-bundle/document-bundle-service';

const {
  REQUEST_GET_PAYER_FILTERS,
  SUCCESS_GET_PAYER_FILTERS,
  FAILURE_GET_PAYER_FILTERS,
  LOADING_GET_PAYER_FILTERS,
} = documentBundleActions;

function* getPayerFilters(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_PAYER_FILTERS });
    const response = yield call(documentBundleService.getPayerFilters, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_PAYER_FILTERS, payload: response.data?.data });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_PAYER_FILTERS, payload: error });
  }
}

function* getPayerFiltersSaga() {
  yield takeLatest(REQUEST_GET_PAYER_FILTERS, getPayerFilters);
}

export default getPayerFiltersSaga;
export { getPayerFilters };
